import React from "react";

const Modal1 = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null; // If modal is not open, return nothing

  const handleBackdropClick = (e) => {
    if (e.target.className === e.currentTarget.className) {
      onClose(); // Close the modal if clicked on the backdrop
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex h-screen  w-screen items-center justify-center bg-black bg-opacity-50 z-50 cursor-default"
      onClick={(e) => {
        handleBackdropClick(e);
        e.stopPropagation();
      }}
    >
      <div
        className=" items-center flex-row justify-center flex  "
        onClick={(e) => {
          handleBackdropClick(e);
          e.stopPropagation();
        }}
        // I want height to fit the content, but also have a max height and width
        style={{
          overflow: "auto",
          height: "100vh",
          width: "100vw",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal1;
